import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useEffect, useMemo, useRef, useState } from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Button } from "../../../../../components";

const NudgeFields = (props) => {
    const {
        nudgeFields,
        setNudgeFields,
        customizeState,
        setCustomizeState,
        handleSave,
        nudgeTitle,
        userPersonaKey,
        globalFields
    } = props;

    // console.log("GlobalFields", globalFields)
    // console.log("Local Fields", nudgeFields)

    const localFields = nudgeFields?.customizeProperties

    const newFields = useMemo(() => {
        const globalProperties = globalFields?.customizeProperties || {};
        const localProperties = nudgeFields?.customizeProperties || {};
        return Object.fromEntries(
            Object.entries(globalProperties).filter(([key]) => !(key in localProperties))
        );
    }, [nudgeFields, globalFields])

    
    return (
        <div className="customisableFields w-full lg:w-1/2 p-2">
            <div className="flex">
                <h3 className='mx-auto text-xl font-semibold'>{nudgeFields.optionName}</h3>
            </div>
            <div className="fields">

                {
                    localFields && Object.entries(localFields).map((el, index) => {

                        const [propertyName, propertyValue] = el

                        return (
                            <Fields
                                key={index}
                                propertyName={propertyName}
                                property={propertyValue}
                                customizeState={customizeState}
                                setCustomizeState={setCustomizeState}
                                nudgeFields={nudgeFields}
                                setNudgeFields={setNudgeFields}
                                nudgeTitle={nudgeTitle}
                            />
                        )

                    })

                }
                {newFields && Object.keys(newFields).length > 0 && (
                    <div
                        style={{
                            opacity: 0.45,
                            pointerEvents: "none",
                            cursor: "not-allowed",
                            filter: "grayscale(30%)",
                            userSelect: "none"
                        }}
                    >
                        {Object.entries(newFields).map((el, index) => {
                            const [propertyName, propertyValue] = el
                            return (
                                <Fields
                                    key={index}
                                    propertyName={propertyName}
                                    property={propertyValue}
                                    customizeState={customizeState}
                                    setCustomizeState={setCustomizeState}
                                    nudgeFields={nudgeFields}
                                    setNudgeFields={setNudgeFields}
                                    nudgeTitle={nudgeTitle}
                                />
                            )
                        })}
                    </div>
                )}
            </div>
            <div className="buttons flex mt-4 items-center justify-center">
                <Button Icon={AiOutlineCloudUpload} active={false} onClick={handleSave} title="SAVE" />
            </div>
        </div >
    )
}

const Fields = (props) => {
    const [maxLengthErrorText, setMaxLengthErrorText] = useState("");

    const {
        propertyName,
        property,
        customizeState,
        setCustomizeState,
        nudgeFields,
        setNudgeFields,
        nudgeTitle,
    } = props;

    const handleNudgeFieldsChange = (name, value) => {
        if (property?.propertyMaxLength && value.length > property.propertyMaxLength) {
            setMaxLengthErrorText(`Max length is ${property.propertyMaxLength}`);
            return;
        }
        setMaxLengthErrorText("");
        let state = {
            ...customizeState,
            [nudgeFields.optionValue]: {
                ...customizeState[nudgeFields.optionValue],
                [name]: value,
            },
        };
        setCustomizeState(state);
        let fields = {
            ...nudgeFields,
            customizeProperties: {
                ...nudgeFields.customizeProperties,
                [name]: {
                    ...(nudgeFields.customizeProperties?.[name] || property),
                    propertyValue: value,
                },
            },
        };
        setNudgeFields(fields);
    };

    const handleCheckBoxChange = (name, value) => {
        let state = {
            ...customizeState,
            [nudgeFields.optionValue]: {
                ...customizeState[nudgeFields.optionValue],
                [name]: value,
            },
        };
        setCustomizeState(state);
        let fields = {
            ...nudgeFields,
            customizeProperties: {
                ...nudgeFields.customizeProperties,
                [name]: {
                    ...(nudgeFields.customizeProperties?.[name] || property),
                    propertyValue: value,
                },
            },
        };
        setNudgeFields(fields);
    };

    return (
        <div className="textField flex flex-col gap-2 sm:px-5 mt-2">
            <div className="textField__container flex flex-col md:flex-row items-center justify-between">
                <RenderField
                    property={property}
                    propertyName={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                    handleCheckBoxChange={handleCheckBoxChange}
                    nudgeTitle={nudgeTitle}
                />
            </div>
            <span className="text-red-500 text-sm">{maxLengthErrorText}</span>
        </div>
    )
};

const RenderField = (props) => {
    const {
        property,
        propertyName,
        handleNudgeFieldsChange,
        handleCheckBoxChange,
    } = props;

    switch (property.propertyType) {
        case "select":
            return (
                <Select
                    property={property}
                    propertyName={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                />
            );
        case "multiSelect":
            return (
                <MultiSelectGeoLocation
                    property={property}
                    propertyName={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                />
            );
        case "text":
        case "color":
        case "url":
        case "number":
            return (
                <Input
                    property={property}
                    propertyName={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                />
            );
        case "inputFieldTitle":
            return (
                <InputFieldTitle
                    property={property}
                    propertyName={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                />
            );
        case "checkbox":
            return (
                <CheckBox
                    property={property}
                    propertyName={propertyName}
                    handleCheckBoxChange={handleCheckBoxChange}
                />
            );
        case "textarea":
            return (
                <TextArea
                    property={property}
                    propertyName={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                />
            );
        case "heroImageURL":
            return (
                <HeroImageURL
                    property={property}
                    propertyName={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                />
            );
        case "media_input":
            return (
                <MediaInputField
                    property={property}
                    propertyKey={propertyName}
                    handleNudgeFieldsChange={handleNudgeFieldsChange}
                />
            );
        default:
            return null;
    }
};

const Select = (props) => {
    const { property, propertyName, handleNudgeFieldsChange } = props;

    return (
        <div className="w-full">
            <label htmlFor={property.propertyName} className="block text-sm font-medium">
                {property.propertyName}
            </label>
            <select
                id={property.propertyName}
                name={property.propertyName}
                onChange={(e) => handleNudgeFieldsChange(propertyName, e.target.value)}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md text-gray-700"
                defaultValue={property.propertyValue}
            >
                {property.propertyOptions.map((option, index) => (
                    <option key={index} value={option.optionValue}>
                        {option.optionName}
                    </option>
                ))}
            </select>
        </div>
    );
};

const MultiSelectGeoLocation = (props) => {
    const { property, propertyName, handleNudgeFieldsChange } = props;
    const [selectedOptions, setSelectedOptions] = useState(
        property.propertyValue === "all" ? property.propertyOptions.map(opt => opt.optionValue) : []
    );
    const [searchTerm, setSearchTerm] = useState("");
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (property.propertyValue !== "all") {
            setSelectedOptions(property.propertyValue);
        }
    }, [property.propertyValue]);

    const handleSelectAll = () => {
        const allOptions = property.propertyOptions.map((option) => option.optionValue);
        setSelectedOptions(allOptions);
        handleNudgeFieldsChange(propertyName, allOptions);
    };

    const handleClearAll = () => {
        setSelectedOptions([]);
        handleNudgeFieldsChange(propertyName, []);
    };

    const handleOptionChange = (optionValue) => {
        const updatedOptions = selectedOptions.includes(optionValue)
            ? selectedOptions.filter((option) => option !== optionValue)
            : [...selectedOptions, optionValue];
        setSelectedOptions(updatedOptions);
        handleNudgeFieldsChange(propertyName, updatedOptions);
    };

    const filteredOptions = property.propertyOptions.filter(option =>
        option.optionName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="w-full" ref={dropdownRef}>
            <label htmlFor={property.propertyName} className="block text-sm font-medium mb-1">
                {property.propertyName}
            </label>
            <div className="relative">
                <div className="flex items-center">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onFocus={() => setIsDropdownVisible(true)}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="mb-2 p-2 border rounded w-full text-black"
                    />
                    <span className="ml-2 text-white">{selectedOptions.length}</span>
                </div>
                {isDropdownVisible && (
                    <div className="absolute z-10 w-full bg-white border rounded mt-1">
                        <div className="flex justify-between items-center mb-2 p-2">
                            <button onClick={handleSelectAll} className="text-sm text-blue-500">Select ALL</button>
                            <button onClick={handleClearAll} className="text-sm text-red-500">Clear ALL</button>
                        </div>
                        <div className="border-t">
                            <div className="max-h-40 overflow-y-scroll p-2">
                                {filteredOptions.map((option, index) => (
                                    <div key={option.optionValue} className="flex items-center mb-1">
                                        <input
                                            type="checkbox"
                                            id={`${property.propertyName}-${option.optionValue}`}
                                            checked={selectedOptions.includes(option.optionValue)}
                                            onChange={() => handleOptionChange(option.optionValue)}
                                            className="mr-2"
                                        />
                                        <label className="text-black" htmlFor={`${property.propertyName}-${option.optionValue}`}>{option.optionName}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const Input = (props) => {
    const { property, propertyName, handleNudgeFieldsChange } = props;
    return (
        <div className="w-full">
            <label htmlFor={property.propertyName} className="block text-sm font-medium">
                {property.propertyName}
            </label>
            <input
                onChange={(e) => handleNudgeFieldsChange(propertyName, e.target.value)}
                className="text-gray-700 py-1 px-2 rounded outline-none w-full"
                type={property.propertyType}
                id={property.propertyName}
                value={property.propertyValue}
            />
        </div>
    );
};

const InputFieldTitle = (props) => {
    const { property, propertyName, handleNudgeFieldsChange } = props;
    const [view, setView] = useState(false);
    const [required, setRequired] = useState(false);
    const [placeholder, setPlaceholder] = useState(property?.propertyValue);
    useEffect(() => {
        if (property.isRequired) setRequired(true);
        if (property.display) setView(true);
    }, []);

    useEffect(() => {
        let newState = [placeholder, view, required];
        handleNudgeFieldsChange(propertyName, newState);
    }, [view, required, placeholder]);
    return (
        <div className="w-full">
            <label htmlFor={property.propertyName} className="block text-sm font-medium">
                {property.propertyName}
            </label>
            <div className="flex flex-col gap-1 items-start">
                <div className="flex justify-between items-center gap-1">
                    {view ? (
                        <EyeIcon
                            onClick={() => setView((prev) => !prev)}
                            className="h-5 w-6 flex-shrink-0 text-green-600 cursor-pointer"
                            aria-hidden="true"
                        />
                    ) : (
                        <EyeSlashIcon
                            onClick={() => setView((prev) => !prev)}
                            className="h-5 w-6 flex-shrink-0 text-red-500 cursor-pointer"
                            aria-hidden="true"
                        />
                    )}
                    <input
                        onChange={(e) => setPlaceholder(e.target.value)}
                        className="text-gray-700 py-1 px-2 rounded outline-none w-full"
                        type={"text"}
                        id={property.propertyName}
                        value={placeholder}
                    />
                </div>
                <div>
                    <input
                        type="checkbox"
                        name="isRequired"
                        checked={required}
                        onChange={() => setRequired((prev) => !prev)}
                    />
                    <label htmlFor="isRequired" className="ml-2">
                        required
                    </label>
                </div>
            </div>
        </div>
    );
};

const TextArea = (props) => {
    const { property, propertyName, handleNudgeFieldsChange } = props;
    return (
        <div className="w-full">
            <label htmlFor={property.propertyName} className="flex text-sm justify-between font-medium">
                <span>{property.propertyName}</span>
                <span className="text-red-300">{property.propertyValue.length}/{property.propertyMaxLength}</span>
            </label>

            <textarea
                onChange={(e) => handleNudgeFieldsChange(propertyName, e.target.value)}
                className="text-gray-700 py-1 px-2 rounded outline-none w-full"
                id={property.propertyName}
                value={property.propertyValue}
            />

        </div>
    );
};

const CheckBox = (props) => {
    const { property, propertyName, handleCheckBoxChange } = props;

    return (
        <div className="w-full">
            <label htmlFor={property.propertyName} className="block text-sm font-medium">
                {property.propertyName}
            </label>
            <input
                onChange={(e) => handleCheckBoxChange(propertyName, e.target.checked)}
                className="text-gray-700 py-1 px-2 rounded outline-none"
                type={property.propertyType}
                id={property.propertyName}
                checked={property.propertyValue}
            />
        </div>
    );
};

const HeroImageURL = (props) => {
    const { property, propertyName, handleNudgeFieldsChange } = props;
    return (
        <div className="w-full">
            <label htmlFor={property.propertyName} className="block text-sm font-medium">
                {property.propertyName}
            </label>
            <div>
                <input
                    onChange={(e) => handleNudgeFieldsChange(propertyName, e.target.value)}
                    className="text-gray-700 py-1 px-2 rounded outline-none w-full"
                    type={"url"}
                    id={property.propertyName}
                    value={property.propertyValue}
                />
            </div>
        </div>
    );
};

const MediaInputField = (props) => {
    const { property, propertyKey, handleNudgeFieldsChange } = props;
    const { propertyValue = [] } = property

    function handleFieldValChange(type, val) {
        if (type === "display") {
            const updatedValue = [...propertyValue];
            updatedValue[0] = val;
            handleNudgeFieldsChange(propertyKey, updatedValue)
        } else if (type === "url") {
            const updatedValue = [...propertyValue];
            updatedValue[1] = val;
            handleNudgeFieldsChange(propertyKey, updatedValue)
        }
    }

    return (
        <div className="w-full">
            <label htmlFor={property.propertyName} className="block text-sm font-medium">
                {property.propertyName}
            </label>

            {/* Main input field */}
            <div className="flex justify-between items-center gap-2 my-2">
                {propertyValue?.[0] ? (
                    <EyeIcon
                        onClick={() => handleFieldValChange("display", !propertyValue?.[0])}
                        className="h-5 w-6 flex-shrink-0 text-green-600 cursor-pointer"
                        aria-hidden="true"
                    />
                ) : (
                    <EyeSlashIcon
                        onClick={() => handleFieldValChange("display", !propertyValue?.[0])}
                        className="h-5 w-6 flex-shrink-0 text-red-500 cursor-pointer"
                        aria-hidden="true"
                    />
                )}
                <input
                    onChange={(e) => handleFieldValChange("url", e.target.value)}
                    className="text-gray-700 py-1 px-2 rounded outline-none col-span-2 border-gray-300 flex-grow w-full"
                    type="url"
                    placeholder="Enter media link eg., https://media.jpg"
                    id={property.propertyName}
                    value={propertyValue[1]}
                />
            </div>
        </div>
    );
};

export default NudgeFields;

